/**
 * Product Tabs — tab switching with accessibility and audio-player support.
 */

class ProductTabs extends HTMLElement {
  constructor() {
    super();

    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = [...this.querySelectorAll('[role="tabpanel"]')];

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.switchTo(tab));
      tab.addEventListener('keydown', (e) => this.onKeydown(e));
    });
  }

  switchTo(selectedTab) {
    const panelId = selectedTab.dataset.tab;

    this.tabs.forEach((tab) => {
      const isSelected = tab === selectedTab;
      tab.classList.toggle('product-tabs__tab--active', isSelected);
      tab.setAttribute('aria-selected', isSelected);
      tab.setAttribute('tabindex', isSelected ? '0' : '-1');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.panel === panelId;
      panel.classList.toggle('product-tabs__panel--active', isActive);
      panel.hidden = !isActive;
    });

    // Audio player canvases need a resize after becoming visible
    if (panelId === 'listen') {
      requestAnimationFrame(() => {
        window.dispatchEvent(new Event('resize'));
      });
    }
  }

  /** Arrow-key navigation between tabs (WAI-ARIA tabs pattern) */
  onKeydown(e) {
    const idx = this.tabs.indexOf(e.currentTarget);
    let next;

    if (e.key === 'ArrowRight') {
      next = this.tabs[(idx + 1) % this.tabs.length];
    } else if (e.key === 'ArrowLeft') {
      next = this.tabs[(idx - 1 + this.tabs.length) % this.tabs.length];
    } else if (e.key === 'Home') {
      next = this.tabs[0];
    } else if (e.key === 'End') {
      next = this.tabs[this.tabs.length - 1];
    }

    if (next) {
      e.preventDefault();
      next.focus();
      this.switchTo(next);
    }
  }
}

customElements.define('product-tabs', ProductTabs);
